<template>
  <div class="can-favorite" v-if="authLoaded">
    <suspense>
      <AuthOverlay v-model:show="authOverlay.show" :data="authOverlay" />
    </suspense>
    <suspense>
      <FavoriteSnackbar :show="showSnackbar" />
    </suspense>
  </div>
</template>

<script>
import { ref, reactive, watch, onMounted, defineAsyncComponent } from 'vue';

import useFavorite from '@/compositions/useFavorite.js';
import UserService from '@/services/UserService';

export default {
  name: 'CanFavorite',
  components: {
    AuthOverlay: defineAsyncComponent(() => import('@/components/shared/AuthOverlay.vue')),
    FavoriteSnackbar: defineAsyncComponent(() => import('@/components/favorite/FavoriteSnackbar.vue')),
  },
  setup() {
    const authOverlay = reactive({
      show: false,
      domRef: null,
    });
    const authLoaded = ref(false);

    const {
      state: favoriteState, //
      targetDomEl,
      showSnackbar,
      addFavoriteItem,
      removeFavoriteItem,
      updateFavoriteProduct,
    } = useFavorite();

    onMounted(() => {
      window.setTimeout(() => {
        authLoaded.value = true;
      }, 2000);
    });

    watch(
      () => authOverlay.show,
      (show, prevShow) => {
        if (show) {
          authLoaded.value = true;
        }
        if (show !== prevShow && !show) {
          if (UserService.isRegistered()) {
            // Refresh apollo client so that we pass the newly generated customer token in header request.
            UserService.refreshUser();
            addFavoriteItem();
          } else {
            removeFavoriteItem();
          }
          updateFavoriteProduct(null);
        }
      },
    );

    watch(
      () => favoriteState.favProduct,
      () => {
        if (!UserService.isRegistered() && favoriteState.favProduct) {
          authOverlay.domRef = targetDomEl.value;
          authOverlay.show = true;
        }
      },
    );

    return {
      showSnackbar,
      authOverlay,
      favoriteState,
      authLoaded,
    };
  },
};
</script>

<style lang="postcss">
@import '@/pixel/style/variables';

.can-favorite {
  max-width: 100%;
  z-index: 9999;
}
</style>
